import React from "react";
import { formatPeriodLabel } from "./formatPeriod.js";

/**
 * A4Page - a single A4 content frame with a running header (title · period)
 * and footer (confidentiality line · page number), used by BoardReportPrint.
 */
const A4Page = ({ title, period, pageNumber, totalPages, children }) => {
  return (
    <div className="a4-page">
      <div className="a4-running-header">
        <span>{title}</span>
        <span>{formatPeriodLabel(period)}</span>
      </div>
      <div className="a4-page-content">
        {children}
      </div>
      <div className="a4-running-footer">
        <span>Confidential — prepared for the board</span>
        <span>Page {pageNumber} of {totalPages}</span>
      </div>
    </div>
  );
};

export default A4Page;
